export const DISABLE_MESSAGE = 'This course is invite-only.';
